import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import Validators from '../../utils/validators'

@observer(['hardware'])
export default class Hardware extends Component {

  constructor(props) {
    super(props)

    this.props.hardware.loadAllHardware()
  }

  newHardware(row) {
    this.props.hardware.newHardware(row)
  }

  updateHardware(row, cellText, cellValue) {
    this.props.hardware.updateHardware(row)
  }

  deleteHardware(id) {
    if (confirm('Are you sure you want to delete this Hardware?')) {
      this.props.hardware.deleteHardware(id)
    }
  }

  formatActions(cell, row) {
    return <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteHardware(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
  }

  render() {
    const options = {
      onAddRow: this.newHardware.bind(this)
    }

    const hardwareTable = (
      <BootstrapTable
          data={ this.props.hardware.data }
          striped={ true }
          hover={ true }
          pagination={ true }
          search={ true }
          exportCSV={ true }
          options={ options }
          insertRow={ true }
          bordered={ false }
          cellEdit={ { mode: 'click', blurToSave: false, afterSaveCell: this.updateHardware.bind(this) } } >
        <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="name" dataSort={ true } editable={{ validator: Validators.validString }}>Name</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="description" dataSort={ true } editable={{ validator: Validators.validString }}>Description</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="baseCost" dataSort={ true } editable={{ validator: Validators.isNumber }}>Base Cost</TableHeaderColumn>
        <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
      </BootstrapTable>
    )

    return (
      <div>
        <Collapsible title="Hardware" content={ hardwareTable } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/hardware.js